import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-app-bar',
  templateUrl: './app-bar.component.html',
  styleUrls: ['./app-bar.component.scss'],
})
export class AppBarComponent implements OnInit {
  userMenuVisible = false;
  tabs = [
    { label: 'gallery', link: '/gallery' },
    { label: 'collections', link: '/collections' },
  ];

  constructor(
    public sharedService: SharedService,
    public userService: UserService,
    public router: Router
  ) {}

  ngOnInit(): void {}
}
